<template>
  <b-modal
    id="allocateusers"
    centered
    hide-header
    hide-footer
    size="xl"
    :visible="showModal"
    @show="getData"
    no-close-on-backdrop
    class="qb-add-ques-modal"
    @hidden="clearData(),$emit('close-modal')"
  >
    <section class="d-flex align-items-center justify-content-between p-3">
      <div class="b-modal-header">Allocate</div>
      <div @click="$emit('close-modal')" class="rotate-on-hover pointer">
        <img src="../../../assets/panelist/blue_cross.svg" alt="" />
      </div>
    </section>
    <hr class="my-0" />

    <section class="p-3">
      <div class="ex-blacktab d-flex justify-content-between text-capitalize">
        {{ modalType }}

        <div class="d-flex justify-content-between mr-2">
          <div class="tp-bluetxt ml-3 mr-4">
            Selected Users:&nbsp; {{ selectedUsers.length }}
          </div>
        </div>
      </div>

      <hr />
      <template v-if="isListView">
        <div
          class="
            d-flex
            justify-content-between
            align-items-center
            w-100
            pt-3
            pl-3
            pr-3
            pb-0
          "
        >
          <div class="relativeclass teams-innerInputField w-50">
            <img
              class="teams-setImage"
              src="../../../assets/img/search-bar-icon.svg"
              alt=""
            />

            <b-form-input
              placeholder="Search Recruiters"
              debounce="500"
              type="search"
              class="search-input"
            >
            </b-form-input>
          </div>
        </div>
        <div class="exc-main-table">
          <div class="exc-table-head">
            <div style="width: 25%">
              <span class="mr-2 pl-4">User name</span>
              <img
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 25%">
              <span class="mr-2">Email</span>
              <img
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 25%">
              <span class="mr-2">Role Type</span>
              <img
                class="pointer"
                src="../../../assets/img/accessconnew/nosort.svg"
                alt=""
              />
            </div>
            <div style="width: 25%">
              <span>Teams</span>
            </div>
          </div>
          <div class="exc-table-body">
            <div class="exc-table-row">
              <div class="w-25 pl-3 d-flex align-items-center">
                <b-form-checkbox class="mr-2"> </b-form-checkbox>AAAA
              </div>
              <div class="w-25">a@gmail.com</div>
              <div class="w-25">Test</div>
              <div class="w-25">dje</div>
            </div>
          </div>
        </div>
        <div
          class="
            acs-paginaTion-new
            d-flex
            justify-content-between
            align-items-center
          "
        >
          <div class="d-flex">
            <span class="acs-gotopage-text p-1 mr-2">Go to page</span>
            <b-form-input
              type="text"
              class="acs-pagination-num"
              v-model="goToPage"
              @keyup.enter="
                goToPage === null || goToPage == '' || iscontainsNumber
                  ? ''
                  : gotopgnum(goToPage)
              "
              @keypress="numbersOnly"
            ></b-form-input>
            <span
              class="acs-pagination-addbtn"
              :class="
                goToPage === null || goToPage == '' || iscontainsNumber
                  ? 'disableDeleteIcon pl-3 mt-1'
                  : 'pointer pl-3 mt-1'
              "
              @click="gotopgnum(goToPage)"
              :disabled="
                goToPage === null || goToPage == '' || iscontainsNumber
              "
            >
              <span
                ><img src="../../../assets/panelist/page_arrow.svg" alt=""
              /></span>
            </span>
          </div>

          <div class="pagination">
            <b-pagination
              align="center"
              first-number
              last-number
              v-model="currentPage"
              :total-rows="total"
              :per-page="configCount"
              @input="getAllConfigs"
            >
              <template #prev-text
                ><span
                  ><img
                    src="../../../assets/img/accessconnew/pageleft.svg"
                    alt=""
                  /> </span
              ></template>
              <template #next-text
                ><span
                  ><img
                    src="../../../assets/img/accessconnew/pageright.svg"
                    alt="" /></span
              ></template>
            </b-pagination>
          </div>
          <div class="d-flex align-items-center">
            <PageInput :pagecount="configCount" @update-value="updatePage" />
            <div class="acs-gotopage-text mr-2 ml-4 d-flex justify-content-end">
              Showing :
              <div
                class="text-truncate ml-2 results-individual-width"
                v-if="pageStart > total"
              >
                0
              </div>
              <div v-else class="text-truncate ml-2 results-individual-width">
                {{ pageStart }}
              </div>
              <div class="text-truncate ml-2 results-individual-width">-</div>
              <div class="text-truncate ml-2 results-individual-width">
                {{ pageEnd }}
              </div>
              <div class="text-truncate ml-2 results-individual-width">
                &nbsp;Of
              </div>
              <div class="text-truncate ml-2 results-individual-width">
                &nbsp;{{ total }}
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="d-flex align-items-center createjobs-left-container">
          <div class="createjobs-teams-left-container">
            <div class="relativeclass w-100 teams-innerInputField">
              <img
                class="teams-setImage"
                src="../../../assets/img/search-bar-icon.svg"
                alt=""
              />

              <b-form-input
                placeholder="Search Folders"
                type="search"
                v-model="searchFolder"
                debounce="500"
                @update="searchFolders"
                class="search-input"
              >
              </b-form-input>
            </div>
            <div class="fw-bold createjobs-teams-checkbox-label my-2">
              Groups
            </div>

            <div class="createjobs-teams-checkbox-container overflow-auto">
              <div class="h-100">
                <b-overlay :show="showLoader" rounded="sm" class="h-100">
                  <template v-if="foldersList.length">
                    <div
                      v-for="(folder, index) in foldersList"
                      :key="index"
                      class="mb-2"
                    >
                      <AllocateFolderCard
                        :expandStatus="expandStatus"
                        :folder="folder"
                        :depth="5"
                        :level="1"
                        :totalSelectedFolderIDs="selectedFolderIDs"
                        :selectedFolder="selectedFolder"
                        :removeList="removeListToLeft"
                        :folderSelectionState="folderSelectionState"
                        @folderId-saved="folderSelectionState = null"
                        @toggle-folder="toggleFolder"
                        @folder-checked="folderSelected"
                        @remove-content="folderRemoved"
                        class="pointer"
                      />
                    </div>
                  </template>
                  <template v-else-if="!showLoader && searchFolder !== ''">
                    <div
                      class="
                        d-flex
                        flex-column
                        align-items-center
                        justify-content-center
                        h-100
                        create-jobs-panelist-no-data
                      "
                    >
                      <img
                        src="../../../assets/img/newcreatejob/allocate-modal-no-data.svg"
                        alt=""
                      />
                      <span class="mt-2">
                        No matching results for "{{ searchFolder }}"
                      </span>
                    </div>
                  </template>
                </b-overlay>
              </div>
            </div>
          </div>
          <div class="craetejob-teams-right-container ml-3">
            <template v-if="selectedFolder">
              <div class="d-flex justify-content-between">
                <div class="w-100">
                  <div class="craetejob-teams-right-head">
                    {{ selectedFolder ? selectedFolder.folderName : "" }}
                  </div>
                  <div class="d-flex">
                    <div
                      class="d-flex align-items-center"
                      :class="{ 'ml-3': index > 0 }"
                      v-for="(breadCrum, index) in breadCrums"
                      :key="index"
                    >
                      <span
                        class="createjob-teams-right-subtxt"
                        :class="{
                          pointer:
                            selectedFolder.folderID !== breadCrum.folderID,
                        }"
                        @click="goToBreadCrum(breadCrum.folderID)"
                        >{{ breadCrum.folderName }}</span
                      >
                      <img
                        class="ml-3"
                        src="../../../assets/img/newcreatejob/teamsdoublearrow.svg"
                        alt=""
                      />
                    </div>
                    <span
                      class="createjob-teams-right-subtxt"
                      :class="{ 'ml-3': breadCrums.length }"
                    >
                      {{ selectedFolder.folderName }}
                    </span>
                  </div>
                </div>
                <div
                  class="
                    d-flex
                    align-items-center
                    justify-content-end
                    w-100
                    mt-2
                  "
                >
                  <div
                    class="d-flex align-items-center teams-user-footer-content"
                  >
                    <div>
                      <img
                        src="../../../assets/New-imgs/teams-icons/teams-very-small-folder.svg"
                        alt=""
                      />
                    </div>
                    <div class="ml-2">
                      {{
                        selectedFolder && selectedFolder.childFolders
                          ? selectedFolder.childFolders.length
                          : 0
                      }}
                    </div>
                  </div>

                  <div
                    class="
                      d-flex
                      align-items-center
                      ml-3
                      teams-user-footer-content
                    "
                  >
                    <div>
                      <img
                        src="../../../assets/New-imgs/teams-icons/teams-very-small-user.svg"
                        alt=""
                      />
                    </div>
                    <div class="ml-2">
                      {{
                        selectedFolder && selectedFolder.users
                          ? selectedFolder.users.length
                          : 0
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <hr class="my-2" />
              <div class="relativeclass w-100 teams-innerInputField">
                <img
                  class="teams-setImage"
                  src="../../../assets/img/search-bar-icon.svg"
                  alt=""
                />

                <b-form-input
                  placeholder="Search"
                  type="search"
                  v-model="searchQuery"
                  debounce="500"
                  @update="getFolderByID(selectedFolder.folderID)"
                  class="search-input"
                >
                </b-form-input>
              </div>
              <b-overlay
                :show="folderLoader"
                rounded="sm"
                class="overflow-auto px-1"
                style="height: calc(100vh - 391px)"
              >
                <template
                  v-if="
                    (selectedFolder.childFolders &&
                      selectedFolder.childFolders.length) ||
                    (selectedFolder.users && selectedFolder.users.length)
                  "
                >
                  <div
                    v-for="folder in selectedFolder.childFolders"
                    :key="folder.folderID"
                    class="pointer"
                    @click="toggleFolder(folder.folderID)"
                  >
                    <div
                      class="
                        createjob-teams-cards
                        mt-2
                        d-flex
                        align-items-center
                        w-100
                      "
                    >
                      <div
                        style="width: 5%"
                        class="common-single-checkbox"
                        @click.stop=""
                      >
                        <b-form-checkbox
                          v-model="selectedFolderIDs"
                          :value="folder.folderID"
                          @change="checkFolderSelect(folder.folderID)"
                        ></b-form-checkbox>
                      </div>
                      <div style="width: 5%">
                        <img
                          src="../../../assets/New-imgs/teams-icons/teams-big-folder.svg"
                          alt=""
                        />
                      </div>
                      <div style="width: 30%">
                        <div
                          class="
                            teams-user-inner-container-head
                            w-90
                            text-truncate
                          "
                        >
                          {{ folder.folderName }}
                        </div>
                        <div class="teams-user-inner-container-createdAt">
                          Created On: Pending
                        </div>
                      </div>
                      <div style="width: 10%" class="d-flex align-items-center">
                        <div>
                          <img
                            src="../../../assets/New-imgs/teams-icons/teams-small-folder.svg"
                            alt=""
                          />
                        </div>
                        <div
                          class="
                            ml-2
                            teams-user-inner-container-count
                            mt-1
                            w-90
                            text-truncate
                          "
                        >
                          {{ folder.noOfFolders }}
                        </div>
                      </div>

                      <div class="d-flex align-items-center" style="width: 10%">
                        <div>
                          <img
                            src="../../../assets/New-imgs/teams-icons/teams-small-user.svg"
                            alt=""
                          />
                        </div>
                        <div class="ml-2 teams-user-inner-container-count mt-1">
                          {{ folder.users.length }}
                        </div>
                      </div>
                      <div
                        style="width: 40%"
                        class="d-flex align-items-center justify-content-center"
                      >
                        <template
                          v-if="folder.users && folder.users.length == 0"
                        >
                          <div class="text-center">-</div>
                        </template>
                        <template v-else>
                          <div
                            class="
                              d-flex
                              align-items-center
                              justify-content-center
                              position-relative
                            "
                            :style="
                              folder.users.length > 3
                                ? 'width: 100px'
                                : folder.users.length == 3
                                ? 'width: 70px;'
                                : folder.users.length == 2
                                ? 'width: 45px;'
                                : folder.users.length == 1
                                ? 'width: 20px;'
                                : ''
                            "
                          >
                            <div
                              v-if="folder.users.length > 0"
                              class="roundDarkBlue"
                              style="left: 0px"
                              v-b-tooltip.hover.top="folder.users[0].username"
                            >
                              {{ folder.users[0].userIcon }}
                            </div>
                            <div
                              v-if="folder.users.length > 1"
                              class="roundDarkBlue"
                              style="left: 25px"
                              v-b-tooltip.hover.top="folder.users[1].username"
                            >
                              {{ folder.users[1].userIcon }}
                            </div>
                            <div
                              v-if="folder.users.length > 2"
                              class="roundDarkBlue"
                              style="left: 50px"
                              v-b-tooltip.hover.top="folder.users[2].username"
                            >
                              {{ folder.users[2].userIcon }}
                            </div>
                            <div
                              v-if="folder.users.length == 4"
                              class="roundDarkBlue"
                              style="left: 75px"
                              v-b-tooltip.hover.top="folder.users[3].username"
                            >
                              {{ folder.users[3].userIcon }}
                            </div>
                            <div
                              v-if="folder.users.length > 4"
                              class="roundLightBlue"
                              style="left: 75px"
                              v-b-tooltip.hover.top="
                                getRemainingNamesTooltip(folder.users)
                              "
                            >
                              +{{ folder.users.length - 3 }}
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                  <div v-for="user in selectedFolder.users" :key="user.userID">
                    <div
                      class="
                        createjob-teams-cards
                        mt-2
                        d-flex
                        align-items-center
                        w-100
                      "
                    >
                      <div style="width: 5%" class="common-single-checkbox">
                        <b-form-checkbox
                          v-model="selectedUsers"
                          :value="convertJSONtoString(user)"
                          @change="checkUserSelection"
                        ></b-form-checkbox>
                      </div>
                      <div style="width: 5%">
                        <img
                          src="../../../assets/New-imgs/teams-icons/teams-big-user.svg"
                          alt=""
                        />
                      </div>
                      <div
                        style="width: 30%"
                        class="
                          teams-user-inner-container-head
                          w-90
                          text-truncate
                        "
                      >
                        {{ user.username }}
                      </div>
                      <div
                        style="width: 30%"
                        class="allocatemodal-email w-90 text-truncate"
                      >
                        {{ user.email }}
                      </div>

                      <div
                        style="width: 30%"
                        class="
                          text-center
                          allocatemodal-email
                          w-90
                          text-truncate
                        "
                      >
                        {{ getUserAndRolesData(user.roles) }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else-if="searchQuery !== '' && !folderLoader">
                  <div
                    class="
                      d-flex
                      flex-column
                      align-items-center
                      justify-content-center
                      h-100
                      create-jobs-panelist-no-data-folder
                    "
                  >
                    <img
                      src="../../../assets/img/newcreatejob/allocate-modal-no-data.svg"
                      alt=""
                    />
                    <span class="mt-3">
                      No matching results for "{{ searchQuery }}"
                    </span>
                  </div>
                </template>
              </b-overlay>
            </template>
            <template v-else>
              <div
                class="
                  h-100
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                "
              >
                <img
                  src="../../../assets/New-imgs/teams-icons/teams_no_folder_content.svg"
                  alt=""
                />
                <div class="teams-empty-container-font mt-3">
                  There are no sub-groups or users. Please select the folder on
                  left to add users
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>

      <div
        class="
          pff-footer-container
          d-flex
          align-items-center
          justify-content-end
          px-3
          pb-3
        "
      >
        <div class="d-flex align-items-center">
          <div class="newoutline">
            <b-button
              variant="padding-4-21 outline-primary mr-3"
              @click="$emit('close-modal')"
              >Cancel</b-button
            >
          </div>

          <div class="newprimarybtn">
            <b-button class="padding-4-21" @click="storeAllocateData"
              >Allocate
            </b-button>
          </div>
        </div>
      </div>
    </section>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import PageInput from "../../../components/InputComponents/PaginationInput.vue";
import { getFolderDetails } from "../../../utils/apiFunctions";
import { selectFolder, usersForList } from "../../../utils/apiClient/jobs";
import AllocateFolderCard from "./AllocateFolderCard.vue";
export default {
  name: "AllocateModal",
  components: {
    PageInput,
    AllocateFolderCard,
  },
  props: {
    showModal: Boolean,
    modalType: String,
    userData: Array,
    folderData: Array,
  },
  data() {
    return {
      isListView: false,
      showLoader: false,
      isFolderCheckFromLeft: false,
      folderLoader: false,
      usersList: [],
      foldersList: [],
      selectedFolderIDs: [],
      selectedUsers: [],
      removeListToLeft: [],
      searchFolder: "",
      searchQuery: "",
      folderSelectionState: null,
      expandStatus: new Set(),
      selectedFolder: null,
      fullSelectedFolder: new Set(),
      breadCrums: [],
    };
  },
  computed: {
    ...mapGetters("userVUEX", {
      getlicenseKey: "getlicenseKey",
    }),
    getExactRole() {
      return this.modalType === "recruiter"
        ? "GET_JOBDASHBOARD"
        : "GET_PANEL_DASHBOARD";
    },
  },
  watch: {
    isListView() {
      this.getData();
    },
  },
  methods: {
    getRemainingNamesTooltip(users) {
      const remainingNames = users.slice(3).map((user) => user.username);
      return remainingNames.join(", ");
    },
    async goToBreadCrum(folderID) {
      if (this.selectedFolder.folderID !== folderID) {
        await this.toggleFolder(folderID);
      }
    },
    async checkFolderSelect(folderID) {
      if (this.selectedFolderIDs.includes(folderID)) {
        await this.folderSelected(folderID);
      } else {
        const index = this.selectedFolderIDs.indexOf(
          this.selectedFolder.folderID
        );
        if (index !== -1) {
          this.selectedFolderIDs.splice(index, 1);
        }
        await this.folderRemoved(folderID);
      }
    },
    clearData() {
      this.usersList = [];
      this.foldersList = [];
      this.selectedFolderIDs = [];
      this.selectedUsers = [];
      this.searchFolder = "";
      this.searchQuery = "";
      this.folderSelectionState = null;
      this.expandStatus.clear();
      this.selectedFolder = null;
    },
    storeAllocateData() {
      const userData = this.selectedUsers.map((user) => JSON.parse(user));
      this.$emit("store-allocate-data", userData, this.selectedFolderIDs);
    },
    getData() {
      this.selectedFolderIDs = [...this.folderData];
      for (let user of this.userData) {
        user = this.convertJSONtoString(user);
        this.selectedUsers.push(user);
      }
      if (this.isListView) {
        this.getUsers();
      } else {
        this.getFolders();
      }
    },
    async getUsers() {
      try {
        const payload = {
          project: "recruitment",
          licenseKey: this.getlicenseKey,
          permission: this.getExactRole,
        };
        const response = await usersForList(payload);
        if (response.status === 200) {
          this.usersList = response.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    checkUserSelection() {
      let isAllSelected = true;
      for (let user of this.selectedFolder.users) {
        user = this.convertJSONtoString(user);
        if (!this.selectedUsers.includes(user)) {
          isAllSelected = false;
          break;
        }
      }
      if (!this.selectedFolder.childFolders.length) {
        if (
          isAllSelected &&
          !this.selectedFolderIDs.includes(this.selectedFolder.folderID)
        ) {
          this.selectedFolderIDs.push(this.selectedFolder.folderID);
          this.folderSelectionState = "add";
        } else if (
          !isAllSelected &&
          this.selectedFolderIDs.includes(this.selectedFolder.folderID)
        ) {
          this.selectedFolderIDs.splice(
            this.selectedFolderIDs.indexOf(this.selectedFolder.folderID),
            1
          );
          this.folderSelectionState = "remove";
        }
      } else {
        if (
          !isAllSelected &&
          this.selectedFolderIDs.includes(this.selectedFolder.folderID)
        ) {
          this.selectedFolderIDs.splice(
            this.selectedFolderIDs.indexOf(this.selectedFolder.folderID),
            1
          );
          this.folderSelectionState = "remove";
        } else if (
          isAllSelected &&
          this.fullSelectedFolder.has(this.selectedFolder.folderID)
        ) {
          this.selectedFolderIDs.push(this.selectedFolder.folderID);
          this.folderSelectionState = "add";
        }
      }
    },
    convertJSONtoString(user) {
      return JSON.stringify({
        username: user.username,
        email: user.email,
        roleName: user.roleName,
        roles: user.roles,
        isActive: user.isActive,
        userID: user.userID,
        landingPage: user.landingPage,
        folderID: user.folderID,
      });
    },
    async folderSelected(folderID) {
      try {
        this.selectedFolderIDs.push(folderID);
        const payload = {
          licenseKey: this.getlicenseKey,
          folderID,
          exactRole: this.getExactRole,
        };
        const response = await selectFolder(payload);
        if (response.status === 200) {
          const userList = response.data.data.userInfo;
          const folderIdList = response.data.data.folderIDs;
          let tempSet = new Set(this.selectedFolderIDs);
          for (const folderId of folderIdList) {
            tempSet.add(folderId);
          }
          this.selectedFolderIDs = [...tempSet];
          tempSet = new Set(this.selectedUsers);
          for (let user of userList) {
            user = this.convertJSONtoString(user);
            tempSet.add(user);
          }
          this.selectedUsers = [...tempSet];
          this.folderSelectionState = "updateArray";
          this.fullSelectedFolder.add(folderID);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async folderRemoved(folderID) {
      try {
        for (const index in this.selectedFolderIDs) {
          if (this.selectedFolderIDs[index] === folderID) {
            this.selectedFolderIDs.splice(index, 1);
          }
        }
        const payload = {
          licenseKey: this.getlicenseKey,
          folderID,
        };
        const response = await selectFolder(payload);
        if (response.status === 200) {
          const userList = response.data.data.userInfo;
          const folderIdList = response.data.data.folderIDs;
          for (const folderId of folderIdList) {
            for (const index in this.selectedFolderIDs) {
              if (folderId === this.selectedFolderIDs[index]) {
                this.selectedFolderIDs.splice(index, 1);
                break;
              }
            }
          }
          for (let user of userList) {
            user = this.convertJSONtoString(user);
            for (const index in this.selectedUsers) {
              if (user === this.selectedUsers[index]) {
                this.selectedUsers.splice(index, 1);
                break;
              }
            }
          }
          this.removeListToLeft = folderIdList;
          this.folderSelectionState = "removeArray";
        }
      } catch (error) {
        console.error(error);
      }
    },
    searchFolders() {
      this.selectedFolder = null;
      this.breadCrums = [];
      this.expandStatus.clear();
      this.getFolders();
    },
    getUserAndRolesData(roles) {
      const roleName = roles.reduce((acc, role, index) => {
        acc += role;
        if (index !== roles.length - 1) {
          acc += ", ";
        }
        return acc;
      }, "");
      return roleName;
    },
    async getFolderByID(folderID) {
      this.folderLoader = true;
      try {
        const payload = {
          project: "recruitment",
          licenseKey: this.getlicenseKey,
          folderID,
          exactRole: this.getExactRole,
          searchQuery: this.searchQuery,
        };
        const response = await getFolderDetails(payload);
        this.selectedFolder = response.data.data.content;
        this.breadCrums = response.data.data.breadCrums.reverse();
        for (const user in this.selectedFolder.users) {
          this.selectedFolder.users[user].folderID = folderID;
        }
        this.setUserIcon();
      } catch (error) {
        console.error(error);
      } finally {
        this.folderLoader = false;
      }
    },
    async toggleFolder(folderID) {
      const tempSet = new Set(this.expandStatus);
      if (tempSet.has(folderID) && this.selectedFolder?.folderID === folderID) {
        tempSet.delete(folderID);
        this.selectedFolder = null;
      } else if (this.selectedFolder?.folderID !== folderID) {
        await this.getFolderByID(folderID);
        tempSet.add(folderID);
      }
      this.expandStatus = new Set(tempSet);
    },
    setUserIcon() {
      this.selectedFolder.childFolders.forEach((folder) => {
        folder.users.forEach((user) => {
          if (user.username.includes(" ")) {
            const first = user.username.split(" ")[0][0].toUpperCase();
            const sec = user.username.split(" ")[1][0].toUpperCase();
            user.userIcon = first + sec;
          } else {
            const value = user.username.slice(0, 2).toUpperCase();
            user.userIcon = value;
          }
        });
      });
    },
    async getFolders() {
      this.showLoader = true;
      try {
        let payload = {
          project: "recruitment",
          licenseKey: this.getlicenseKey,
          exactRole: this.getExactRole,
          searchFolder: this.searchFolder,
        };
        const response = await getFolderDetails(payload);
        if (response.status === 200) {
          this.foldersList = response.data.data.tree;
          this.showLoader = false;
        }
      } catch (error) {
        console.error(error);
      }
    },
    numbersOnly(evt) {
      if (evt.target.nodeName === "INPUT") {
        const charCode = evt.key;

        if ((charCode < "0" || charCode > "9") && charCode !== ".") {
          evt.preventDefault();
        } else {
          return true;
        }
      }
    },
  },
};
</script>
<style>
.createjobs-left-container {
  height: calc(100vh - 275px);
}
.createjobs-teams-checkbox-container {
  border: 1px solid #8c8c8c54;
  padding: 10px;
  background: #ffffff;
  border-radius: 6px;
  height: calc(100vh - 370px);
}
.roundDarkBlue {
  width: 30px;
  height: 30px;
  background-color: #20639b;
  border: 1px solid white;
  border-radius: 50%;
  font-size: 10px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.roundLightBlue {
  width: 30px;
  height: 30px;
  background-color: #e9f0f5;
  border: 1px solid white;
  border-radius: 50%;
  font-size: 10px;
  color: #20639b;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}
.exc-main-table {
  width: 100%;
  position: relative;
  height: calc(100vh - 365px);
  overflow-x: auto;
  overflow-y: hidden;
  padding: 20px;
}

.exc-table-head {
  min-width: 1000px;
  max-width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 0px;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #20639b;
  font-family: "lato", sans-serif;
  background: #20639b1a;
}

.exc-table-body {
  min-width: 1000px;
  max-width: 100%;
  overflow-y: auto;
  height: calc(100vh - 428px);
}

.exc-table-row {
  width: 100%;
  position: relative;
  border-radius: 3px;
  border: 0.5px solid #e5e5e5;
  background: #fcfcfc;
  box-shadow: 0px 4px 15px 0px #c4c4c480;
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 15px;
  color: #20639b;
  font-family: "lato", sans-serif;
  padding: 5px 0px;
  margin: 8px 0px;
}

.exc-table-row:hover {
  background: #e7e8f5;
}

.exc-bluebtn {
  width: 95%;
  /* padding: 7px 23px; */
  border: 1px solid #20639b;
  box-shadow: 0px 4px 20px 0px #1a416433;
  border-radius: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-M);
  color: var(--bluetheme);
}

.exc-redbtn {
  width: 95%;
  /* padding: 7px 23px; */
  border: 1px solid #eb000280;
  border-radius: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-M);
  color: #eb0002;
}

.exc-greenbtn {
  width: 95%;
  /* padding: 7px 23px; */
  border: 1px solid #038e0080;
  border-radius: 35px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "montserrat", sans-serif;
  font-size: var(--size-12);
  font-weight: var(--weight-M);
  color: #7a7a7a;
}

.exc-gridgreencolorDynamic {
  width: 4px;
  height: 51px;
  border-radius: 3px;
  position: absolute;
  left: 1px;
  top: -13px;
  background: #20639b;
}

.exc-dropdown-field {
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px 0px #1018280d;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 37px;
}

.create-jobs-panelist-no-data {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #696969;
}
.create-jobs-panelist-no-data-folder {
  font-weight: 600;
  font-size: 14px;
  color: black;
}
</style>
